import React from "react";

export type WorkOrderAssetTooltipItem = {
  _id: string;
  name?: string;
  serialNumber?: string;
  isDeleted?: boolean;
};

type WorkOrderAssetsTooltipContentProps = {
  assets: WorkOrderAssetTooltipItem[];
  title?: string;
};

export const WorkOrderAssetsTooltipContent: React.FC<
  WorkOrderAssetsTooltipContentProps
> = ({ assets, title }) => (
  <div className="flex max-w-[20rem] flex-col gap-xs min-w-0">
    <div className="font-bold shrink-0">
      {title ?? `${assets.length} Assets`}
    </div>
    <div className="max-h-[min(15rem,50vh)] overflow-y-auto overflow-x-hidden overscroll-contain">
      {assets.map((asset) => (
        <div key={asset._id} className="break-all">
          • {asset.name} • {asset.serialNumber}
        </div>
      ))}
    </div>
  </div>
);
